(ns hai.ui.components.form.select.add-or-invite-users
  (:require
   [clojure.string :as str]
   [field :as-alias field]
   [hai-model.model :as model]
   [hai.users.helper :as users]
   [hai.ui.components :as c]
   [hai.ui.components.card :as card]
   [hai.ui.components.collection.settings :as settings]
   [hai.ui.components.collection.table :as collection]
   [hai.ui.components.collection.views.cards :as cards]
   [hai.ui.components.collection.views.table :as table]
   [hai.ui.components.form.select.components :as select.components]
   [hai.ui.components.form.select.multi-select :as multi-select]
   [hai.ui.components.form.select.searchable-multi-select :as searchable-select]
   [lambdaisland.ornament :as o]
   [medley.core :refer [assoc-some]]))

;; NOTE Our system normalises all email addresses to their lower case equivalent but we do that
;; server side, this regex (which is a modified version of what we use elsewhere in our codebase)
;; matches all cases.
(let [email-regex #"(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|\"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*\")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])"]
  (defn extract-email
    [s]
    (loop [s s
           res []]
      (if-let [match (first (re-find email-regex s))]
        (let [index (str/index-of s match)
              prefix (subs s 0 index)
              postfix (subs s (+ index (count match)))]
          (recur postfix
                 (conj res (assoc-some
                            {:user/email [match]
                             :user/uuid (random-uuid)
                             ::extracted? true}
                            :user/full-name (not-empty prefix)))))
        res))))

(o/defstyled add-users-field* :div
  :relative
  :flex :flex-col :gap-3
  [:.search-bar :flex :gap-3 :items-center
   [:.search-field :w-100%]]
  ([{:as select
     {{:form.field/keys [set-value! current-value]} :multi-select/selected
      {search :form.field/current-value} :table/search} :form/fields}]
   [:<>
    [:div.search-bar
     [:div.search-field [multi-select/select-input select]]
     [settings/menu select]]
    (let [searches (-> select :form/current-value :table/rows)
          ;; TODO this should be a negative filter... only search for users I don't already have.
          extracted (when (and (not (seq searches))
                               search)
                      (extract-email search))
          selected (into []
                         (map (fn [{::keys [extracted?] :as user}]
                                (if extracted?
                                  (assoc user :entity/new? true)
                                  user)))
                         (-> select :form/current-value :multi-select/selected))
          selected-uuid? (into #{} (map :user/uuid) selected)
          searches (into []
                         (remove (fn [search]
                                   (selected-uuid? (:user/uuid search))))
                         searches)
          selected-email? (into #{} (map :user/email) selected)
          extracted (into []
                          (remove (fn [search]
                                    (selected-email? (:user/email search))))
                          extracted)
          rows (-> []
                   (into searches)
                   (into extracted)
                   (into selected))
          id [(:form/id select) ::users-field-table-id]]
      [collection/component
       {:id id
        :rows rows
        :controls collection/empty-controls
        :selected selected
        :on-select set-value!
        ;; TODO this is a hack, this would be what we need for the editable table to be used as the
        ;; value of the enclosing field. Instead we pull the value out the app-db directly as firing
        ;; this will cause the form to re-render and then we lose field focus in this editable
        ;; table.
        ;; :on-change set-value!
        :show-selected-toggle? true
        :schema model/User
        :update-mutation 'not/used
        ;; TODO default card render
        :card (fn [collection item]
                [card/card
                 [cards/card-select-checkbox collection item]
                 [cards/column-render collection item]])
        :columns [{:header "Email"
                   :attr   :user/email
                   :render (fn [{:user/keys [email]}]
                             [table/table-cell
                              (str/join ", " email)])}
                  {:header "Name"
                   ;; TODO this has been removed for now due to the complicated nature of the hacks,
                   ;; see above.
                   ;; :field col.form/input
                   ;; :render (fn [{::keys [extracted?]}]
                   ;;           [table/table-cell
                   ;;            (when extracted? [c/Text [:em "Select user to edit"]])])
                   :attr   :user/full-name}
                  {:header "Status"
                   :render (fn [{::keys [extracted?]}]
                             [table/table-cell
                              [:span
                               (cond
                                 extracted? [c/Tooltip
                                             {:content "A new user will be created. Select the user to edit before creation."}
                                             [c/Code "New"]]
                                 :else [c/Tooltip
                                        {:content "The existing user will be used."}
                                        [c/Code "Existing"]])]])}]}])]))

(defn field
  [field]
  [searchable-select/field
   (assoc field
     :query [{:users/table [{:collection/items users/query}]}]
     :render {:style select.components/radix
              :field add-users-field*}
     :placeholder "Find or invite users...")])

